// extracted by mini-css-extract-plugin
module.exports = {"layout":"Container_layout__8y0SQ","currencies":"Container_currencies__8HCzK","reviewBlock":"Container_reviewBlock__xqr3L","hotServicesBlock":"Container_hotServicesBlock__YG0N_"};